<template>
  <navbar btnBackground="bg-gradient-success" />
  <div
    class="page-header align-items-start min-vh-100"
    style="
      background-image: url('https://images.unsplash.com/photo-1497294815431-9365093b7331?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1950&q=80');
    "
  >
    <span class="mask bg-gradient-dark opacity-6"></span>
    <div class="container my-auto">
      <div class="row">
        <div class="col-lg-4 col-md-8 col-12 mx-auto">
          <div class="card z-index-0 fadeIn3 fadeInBottom">
            <div class="card-header p-0 position-relative mt-n4 mx-3 z-index-2">
              <div
                class="bg-gradient-success shadow-success border-radius-lg py-3 pe-1"
              >
                <h4 class="text-white font-weight-bolder text-center mt-2 mb-0">
                  교육부 만나 관리자
                </h4>
                <div class="row mt-3">
        
                </div>
              </div>
            </div>
            <div class="card-body">
              <form role="form" @submit.prevent="handleLogin">
                <div class="mb-3">
                  <input
                    id="phone"
                    type="text"
                    class="form-control"
                    v-model="phone"
                    placeholder="휴대폰번호"
                    style="width:90%; border: 1px solid gray;"
                  />
                </div>
                <div class="mb-3">
                  <input
                    id="password"
                    type="password"
                    class="form-control"
                    v-model="password"
                    placeholder="비밀번호"
                    style="width:90%; border: 1px solid gray;"
                  />
                </div>
                <!-- <material-switch id="rememberMe" name="rememberMe"
                  >Remember me</material-switch
                > -->
                <div class="text-center">
                  <button
                    type="submit"
                    class="btn bg-gradient-success w-100 my-4 mb-2"
                  >
                    LOGIN
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <footer class="footer position-absolute bottom-2 py-2 w-100">
      <div class="container">
        <div class="row align-items-center justify-content-lg-between">
          <div class="col-12 col-md-6 my-auto">
          </div>
          <div class="col-12 col-md-6">            
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import Navbar from "@/common/PageLayout/Navbar.vue";
//import MaterialInput from "@/components/MaterialInput.vue";
//import MaterialSwitch from "@/components/MaterialSwitch.vue";
import { mapMutations } from "vuex";
import apiservice from "../services/apiservice";

export default {
  name: "sign-in",
  components: {
    Navbar,
    //MaterialInput,
    //MaterialSwitch,
  },
  data() {
    return {
        phone: "",
        password: "",
    };
  },
  methods: {
    ...mapMutations(["toggleEveryDisplay", "toggleHideConfig"]),
    parseJwt(token) {
      try {
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
        return JSON.parse(jsonPayload);
      } catch (e) {
        console.error('Error parsing JWT:', e);
        return null;
      }
    },
    async handleLogin() {
      if (!this.phone || !this.password) {
        alert("휴대폰번호와 비밀번호를 입력해주세요.");
        return;
      }

      try {
        const data = {
          phone: this.phone,
          password: this.password
        };

        const response = await apiservice.login(data);
        
        if (response.data.success) {
          const token = response.data.token;
          // Store token in localStorage
          localStorage.setItem("token", token);

          // Parse JWT token and get user data
          const decodedToken = this.parseJwt(token);
          console.log('Decoded token:', decodedToken);

          if (decodedToken && decodedToken.data) {
            // Vuex에 로그인 데이터 저장
            await this.$store.dispatch('login', decodedToken.data);
          } else {
            throw new Error('Invalid token data');
          }
          
          // Redirect to /dashboard
          this.$router.push("/dashboard");
        } else {
          alert("아이디, 비밀번호를 확인해주세요");
        }
      } catch (error) {
        console.error("Login error:", error);
        alert("로그인 중 오류가 발생했습니다. 다시 시도해주세요.");
      }
    }
  },
  beforeMount() {
    this.toggleEveryDisplay();
    this.toggleHideConfig();
  },
  beforeUnmount() {
    this.toggleEveryDisplay();
    this.toggleHideConfig();
  },
};
</script>